export const STUCK_TIMEOUT = 30000;
